module.exports = __webpack_public_path__ + "static/media/user.bc5b11bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user.svg
// module id = 51
// module chunks = 0